// extracted by mini-css-extract-plugin
export default {"button":"ToolbarButton_button__wsTlJ","icon":"ToolbarButton_icon__XVqUK"};